import { useEffect, useState } from "react";

export const useElementWidth = <T extends HTMLElement>(): [
  (node: T | null) => void,
  number
] => {
  const [node, setNode] = useState<T | null>(null);
  const [width, setWidth] = useState(0);

  useEffect(() => {
    if (!node) return;

    const observer = new ResizeObserver(([entry]) => {
      setWidth(entry.contentRect.width);
    });

    observer.observe(node);

    return () => observer.disconnect();
  }, [node]);

  return [setNode, width];
};
